import { Category } from 'domains/category';
import { Media } from 'domains/media';

export class InstagramPost {
  constructor(
    public caption: string,
    public category: Category | undefined,
    public createdAt: Date,
    public id: number,
    public instagramPostId: string,
    public media: Media,
    public rejectedReason: string | null,
    public status: 'pending' | 'approved' | 'rejected',
    public updatedAt: Date,
    public url: string | null,
    public userId: number
  ) {}
}
